<template>
  <v-container fluid>
    <Title
      v-if="$vuetify.breakpoint.smAndUp"
      :src="'popular'"
      :text="'Popular'"
    />
    <Loader v-if="!popular" />
    <v-row v-else class="background-color-white mb-0 mb-sm-6 mr-sm-0 px-sm-6">
      <XsTitle v-if="$vuetify.breakpoint.xsOnly" :text="'Popular'" />
      <v-col
        v-for="(product, index) in popular.slice(0, 20)"
        class="mb-sm-5 pa-0 pa-sm-3 position-relative"
        :key="index"
        cols="6"
        md="3"
        xl="2"
      >
        <Product
          :product="product"
          :size="$vuetify.breakpoint.xsOnly ? 'xs' : 'md'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Loader from "@/components/UI/Loader.vue";
import Product from "@/components/Product/index.vue";
import Title from "@/components/UI/Title.vue";
import XsTitle from "@/components/UI/Xs/Title.vue";

export default {
  name: "PopularView",
  components: { Loader, Product, Title, XsTitle },
  computed: {
    ...mapState({
      popular: (state) => state.popular.data,
    }),
  },
};
</script>
